import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from "redux-form";
import moment from 'moment';
import DateTime from '_class/DateTime';
import { addError } from 'actions';
import { getMeetingTimeBlocks } from 'actions/timeblocks';
import { updateMeetingInstanceDate } from 'actions/meetings';
import { Collapsible, Spinner } from 'UI';
import { Plus, Minus } from 'UI/Icons';
import { Button, Radio, Flex } from '@haldor/ui';
import './_BookMeeting.scss';

var BookMeeting = /*#__PURE__*/function (_Component) {
  _inherits(BookMeeting, _Component);

  var _super = _createSuper(BookMeeting);

  function BookMeeting(props) {
    var _this;

    _classCallCheck(this, BookMeeting);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      Promise.all([_this.props.getMeetingTimeBlocks(_this.props.meeting.id)]).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value, values) {
      if (value == null) {
        return _this.props.translate("field-needs-input");
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var onClose = _this.props.onClose;
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var slots, slot, date, endTime, obj;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  slots = [];

                  _this.props.meetingTimeBlocks.map(function (timeBlock) {
                    slots.push.apply(slots, _toConsumableArray(timeBlock.timeBlockSlots));
                  });

                  slot = slots.find(function (item) {
                    return item.id == values.timeBlockSlotId;
                  });

                  if (!(slot != null)) {
                    _context.next = 11;
                    break;
                  }

                  date = moment.utc(slot.startTime);
                  endTime = moment.utc(slot.endTime);
                  obj = {
                    id: _this.props.instance.id,
                    meetingId: _this.props.meeting.id,
                    timeBlockSlotId: slot.id,
                    date: date.format('YYYY-MM-DDTHH:mm:ss'),
                    endDate: endTime.format('YYYY-MM-DDTHH:mm:ss')
                  };

                  _this.setState({
                    loading: true
                  });

                  _this.props.updateMeetingInstanceDate(obj).then(function () {
                    onClose(null, true);
                  });

                  _context.next = 14;
                  break;

                case 11:
                  _this.props.addError(_this.props.translate('The time you selected is no longer available. Please choose a different time.'), 'error');

                  resolve(1);
                  return _context.abrupt("return");

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      // Prevent button submitting form
      event.preventDefault();

      _this.props.onClose(null, false);
    });

    _this.state = {
      dates: null,
      loading: true
    };
    return _this;
  }

  _createClass(BookMeeting, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;

      if (this.props.meetingTimeBlocks == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '2rem'
          },
          className: "text--center color--meta"
        }, this.props.translate('no-bookable-times')));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: ""
      }, this.props.meetingTimeBlocks.map(function (timeblock) {
        var trigger = function trigger(open) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'flex'
            }
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              flex: '1'
            }
          }, new DateTime(timeblock.startTime).getDateString().capitalize()), /*#__PURE__*/React.createElement(Flex, {
            center: true
          }, new DateTime(timeblock.startTime).getTime(), ' - ', new DateTime(timeblock.endTime).getTime(), /*#__PURE__*/React.createElement("div", {
            className: "open-indicator"
          }, open ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null))));
        };

        var slots = timeblock.timeBlockSlots.filter(function (t) {
          return moment(t.startTime) < moment(timeblock.endTime) && moment(t.endTime) > moment(timeblock.startTime);
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "meeting--slots",
          key: timeblock.id
        }, /*#__PURE__*/React.createElement(Collapsible, {
          trigger: trigger
        }, /*#__PURE__*/React.createElement("div", {
          className: "slots-container"
        }, slots.map(function (slot, i) {
          var startTime = moment.utc(slot.startTime).local();
          var label = startTime.format('HH:mm');
          var available = slot.available && startTime.unix() > moment().unix();
          var bookable = slot.bookable;

          if (_this2.props.instance != null) {
            if (_this2.props.instance.timeBlockSlotId == slot.id) {
              available = true;
              label = label + ' ' + _this2.props.instance.student.firstName + ' ' + _this2.props.instance.student.lastName;
            }
          }

          return /*#__PURE__*/React.createElement("div", {
            className: "slot",
            key: slot.id
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            optionValue: slot.id,
            disabled: !available || !bookable,
            name: "timeBlockSlotId",
            label: label,
            validate: _this2.required,
            key: slot.id
          }));
        }))));
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: !valid
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return BookMeeting;
}(Component);

function mapStateToProps(state, ownProps) {
  var initialValues = null;

  if (ownProps.instance != null) {
    initialValues = _objectSpread(_objectSpread({}, ownProps.instance), {}, {
      timeBlockSlotId: ownProps.instance.timeBlockSlotId,
      date: moment.utc(ownProps.instance.date).local().format('YYYY-MM-DDTHH:mm:ss')
    });
  }

  return {
    initialValues: initialValues,
    translate: translate(state.Languages.translations),
    meetingTimeBlockSlots: state.TimeBlocks.meetingTimeBlockSlots,
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks
  };
}

;
export default connect(mapStateToProps, {
  getMeetingTimeBlocks: getMeetingTimeBlocks,
  updateMeetingInstanceDate: updateMeetingInstanceDate,
  addError: addError
})(reduxForm({
  form: 'BookMeetingBlocks',
  destroyOnUnmount: true
})(BookMeeting));